import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function initPeople() {

	const itemCards = document.querySelectorAll('.people');

	itemCards.forEach(el => {
		const slider = el.querySelector('.swiper');

		const swiper = new Swiper(slider, {
			modules: [Navigation],
	    slidesPerView: 'auto',
	    slidesOffsetAfter: 24,
	    slidesOffsetBefore: 24,
	    simulateTouch: false,
	    spaceBetween: 20,
	    speed: 600,
	    loop: false,
		  // Navigation arrows
		  navigation: {
		    nextEl: el.querySelector('.swiper-button-next'),
		    prevEl: el.querySelector('.swiper-button-prev'),
		  },
		  breakpoints: {
		  	992: {
		  		slidesPerView: 3,
			    slidesOffsetAfter: 0,
			    slidesOffsetBefore: 0,
		  	}
		  }
	  });

	});


}